import Odnoklassniki from './Odnoklassniki'

export default Odnoklassniki
// eslint-disable-next-line import/export
export * from './Odnoklassniki'
